import Menus from "../Menus";

const HelpTopicInfoCompte = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Gérer votre compte', link: '/topics/compte/gestion-compte'},
  ]
  
  const multiMenus = [
    {title: 'Modifier les informations de votre compte', filter: 'HelpTopicInfoCompte_1'},
    {title: 'Gérer votre profil', filter: 'HelpTopicInfoCompte_2'},
    {title: 'Désactiver ou supprimer', filter: 'HelpTopicInfoCompte_3'},
    {title: 'Notifications', filter: 'HelpTopicInfoCompte_4'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicInfoCompte